import { Button } from "@/components/Button"
import { FormCheckbox } from "@/components/Form/Checkbox"
import { Modal } from "@/components/Modal"
import { useCallback, useLayoutEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { useRainApi } from "./useApi"

const Agreement = () => {
  const history = useHistory()
  const [showMessage, setShowMessage] = useState(false)
  const [enable, setEnable] = useState(false)
  const { formModel, control, handleSubmit, onSubmit } = useRainApi("agree", () => setShowMessage(true))
  const getValues = formModel.getValues
  const handleChange = useCallback(() => {
    const values = Object.values(getValues())
    setEnable(values.length > 0 && values.every((val) => val !== "" && val != null))
  }, [getValues])
  useLayoutEffect(() => {
    const values = Object.values(getValues())
    setEnable(values.length > 0 && values.every((val) => val !== "" && val != null))
  }, [getValues])

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} onChange={handleChange} className="[&_a]:font-bold">
      <Modal show={showMessage} onClose={() => setShowMessage(false)} title="Complete Company Verification">
        <p></p>
      </Modal>
      <Modal show={showMessage} title="Complete Company Verification" onClose={() => history.push("/company-verification")}>
        <div className="text-black text-[16px] max-w-[500px] mt-3">
          We’ve sent a verification link for your company to your email. Please follow the link to complete the verification
        </div>
        <div className="flex justify-end mt-4">
          <Button onClick={() => history.push("/company-verification")}>Close</Button>
        </div>
      </Modal>
      <h1 className="text-2xl text-black mb-4">Agree to Tranzbase Card Terms</h1>
      <label className="w-full border border-gray-100 p-4 bg-gray-50">
        <FormCheckbox
          required
          name="sign"
          control={control}
          label={
            <p>
              I accept the <a href="/legal/e-sign-consent">E-Sign Consent</a>
            </p>
          }
        />
      </label>
      <label className="w-full border border-gray-100 p-4 bg-gray-50 my-3">
        <FormCheckbox
          required
          name="card-terms"
          control={control}
          label={
            <p>
              I accept the <a href="/legal/corporate-card-terms">International Business Card Terms</a>, and the{" "}
              <a rel="noopener noreferrer" href="https://www.third-national.com/privacypolicy" target="_blank">
                Issuer Privacy Policy
              </a>
            </p>
          }
        />
      </label>
      <label className="w-full border border-gray-100 p-4 bg-gray-50 mb-3">
        <FormCheckbox
          required
          name="certify"
          control={control}
          label={
            <p>
              I certify that the information I have provided is accurate and that I will abide by all the rules and requirements related to my
              Tranzbase Spend Card.
            </p>
          }
        />
      </label>
      <label className="w-full border border-gray-100 p-4 bg-gray-50">
        <FormCheckbox
          required
          name="asknow"
          control={control}
          label={<p>I acknowledge that applying for the Tranzbase Spend Card does not constitute unauthorized solicitation.</p>}
        />
      </label>

      <Button disabled={!enable} className="w-full mt-3" variant="contained" color="primary">
        Continue
      </Button>
    </form>
  )
}

export default Agreement
